export default __webpack_public_path__ + "static/media/view-all-arrow-icon.81b6ba63.svg";